import { Stack } from '@chakra-ui/react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import NavItem from './NavItem';
import { getNavigationItems } from './navigationConfig';

interface NavigationMenuProps {
  onItemClick?: () => void;
}

function NavigationMenu({ onItemClick }: NavigationMenuProps) {
  const { t } = useTranslation('common');
  const location = useLocation();

  const navigationItems = getNavigationItems();

  return (
    <Stack direction="column" gap={2} align="stretch">
      {navigationItems.map((item) => (
        <NavItem
          key={item.to}
          to={item.to}
          icon={item.icon}
          isActive={
            item.to === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(item.to)
          }
          onClick={onItemClick}
        >
          {t(item.label)}
        </NavItem>
      ))}
    </Stack>
  );
}

export default NavigationMenu;
